/* Quote Builder — Collection → Type(product_type) → Product → Variant(SKU)
   - Collections from Menu (preferred) or Section Blocks (fallback)
   - Costs configurable in CONFIG
   - Uses window.WEB3FORMS_KEY if present (theme setting)
   - Modal summary after submit; clears Add form after each Add
*/
(function(){
  const CONFIG = {
    WEB3FORMS_ACCESS_KEY:
      (window.WEB3FORMS_KEY && String(window.WEB3FORMS_KEY).trim()) || "YOUR_FALLBACK_KEY_HERE",

    PHONE_SUPPORT: "484.212.6363",
    ADDRESS_SUPPORT: "283 South Oak Street, Manheim, PA 17545",

    CUTOUT_PRICE: 5,  // $ per cut-out
    EDGE_UPCHARGES: { // flat $ by edge type
      "": 0,
      "Eased": 0,
      "Beveled": 10,
      "Bullnose": 15,
      "Ogee": 25
    },

    CURRENCY: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
    priceFormatter: null
  };
  CONFIG.priceFormatter = new Intl.NumberFormat(undefined, { style: "currency", currency: CONFIG.CURRENCY });

  // State
  const state = {
    currentCollection: { handle: "", title: "" },
    products: [],
    filtered: [],
    items: []
  };

  // Elements
  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const elModalDownload = document.getElementById('qb-modal-download');

  const elCollection = $('#qb-collection');
  const elType       = $('#qb-type');
  const elProduct    = $('#qb-product');
  const elVariant    = $('#qb-variant');

  const elSqft     = $('#qb-sqft');
  const elCutouts  = $('#qb-cutouts');
  const elEdge     = $('#qb-edge');
  const elQty      = $('#qb-qty');
  const elNote     = $('#qb-note');

  const elAdd      = $('#qb-add');
  const elTbody    = $('#qb-tbody');
  const elEmpty    = $('#qb-empty');
  const elSubtotal = $('#qb-subtotal');

  const elName     = $('#qb-name');
  const elEmail    = $('#qb-email');
  const elPhone    = $('#qb-phone');
  const elPhoneExt = $('#qb-phone-ext');
  const elAddress  = $('#qb-address');
  const elCustNote = $('#qb-custnote');
  const elSubmit   = $('#qb-submit');
  const elStatus   = $('#qb-status');

  // Modal elements
  const elModal        = document.getElementById('qb-modal');
  const elModalSummary = document.getElementById('qb-modal-summary');
  const elModalNew     = document.getElementById('qb-modal-new');

  // Utils
  const fmt = (v) => CONFIG.priceFormatter.format(Number(v || 0));
  const unique = (arr) => Array.from(new Set(arr.filter(Boolean)));
  function esc(s){ return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }

  function openModal() {
    if (!elModal) return;
    elModal.classList.add('is-open');
    elModal.setAttribute('aria-hidden', 'false');
  }
  function closeModal() {
    if (!elModal) return;
    elModal.classList.remove('is-open');
    elModal.setAttribute('aria-hidden', 'true');
  }

  function renderPrettySummary(payload){
    const when = new Date(payload.meta.generated_at || Date.now());
    const dateStr = when.toLocaleString();

    const cust = payload.customer || {};
    const items = payload.items || [];
    const subtotal = payload.totals?.subtotal || 0;

    const rows = items.map((it, i) => `
      <tr>
        <td>${i+1}</td>
        <td class="qb-wrap-text">
          <div><strong>${esc(it.product_title || '')}</strong></div>
          <div class="qb-small">Collection: ${esc(it.collection || '—')}</div>
          <div class="qb-small">Type: ${esc(it.type || '—')}</div>
          <div class="qb-small">Variant: ${esc(it.variant_title || '—')} • SKU: ${esc(it.sku || '—')}</div>
        </td>
        <td>
          <div>Qty: ${esc(it.qty || '—')}</div>
          <div>Sqft: ${esc(it.sqft || '—')}</div>
          <div>Cut outs: ${esc(it.cutouts || '0')}</div>
          <div>Edge: ${esc(it.edge || 'Standard')}</div>
        </td>
        <td class="qb-s-right">${fmt(it.unit_price || 0)}</td>
        <td class="qb-s-right">${fmt(it.line_total || 0)}</td>
      </tr>
    `).join('');

    return `
      <div class="qb-s-grid">
        <div class="qb-s-card">
          <h3>Customer</h3>
          <div class="qb-kv">
            <span>Name</span><span>${esc(cust.name)}</span>
            <span>Email</span><span>${esc(cust.email)}</span>
            <span>Phone</span><span>${esc(cust.phone_display)}${cust.phone_ext ? ' x' + esc(cust.phone_ext) : ''}</span>
            ${cust.address ? `<span>Address</span><span>${esc(cust.address)}</span>` : ``}
            ${cust.note ? `<span>Note</span><span>${esc(cust.note)}</span>` : ``}
          </div>
        </div>
        <div class="qb-s-card">
          <h3>Quote Total</h3>
          <div class="qb-total">${fmt(subtotal)}</div>
          <div class="qb-small">Generated: ${esc(dateStr)}</div>
          <div class="qb-small">${esc(CONFIG.PHONE_SUPPORT)} • ${esc(CONFIG.ADDRESS_SUPPORT)}</div>
        </div>
      </div>

      <div class="qb-s-card">
        <h3>Items</h3>
        <table class="qb-s-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Details</th>
              <th class="qb-s-right">Unit</th>
              <th class="qb-s-right">Line Total</th>
            </tr>
          </thead>
          <tbody>${rows || ''}</tbody>
          <tfoot>
            <tr>
              <th colspan="4" class="qb-s-right">Subtotal</th>
              <th class="qb-s-right">${fmt(subtotal)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    `;
  }

  function resetAddForm(resetCollection){
    if (resetCollection){
      // Reset the Collection dropdown back to the placeholder
      elCollection.value = "";
      state.currentCollection = { handle: "", title: "" };
      state.products = [];
    }
    // Disable and clear dependent selects
    clearAfterCollection();

    // Clear per-item inputs
    elSqft.value = '';
    elCutouts.value = '0';
    elEdge.value = '';
    elQty.value = '1';
    elNote.value = '';
  }

  function computeLineTotal(unitPrice, sqft, qty, cutouts, edge){
    const p = Number(unitPrice || 0);
    const s = Math.max(0, Number(sqft || 0));
    const q = Math.max(0, Number(qty  || 0));
    const c = Math.max(0, Number(cutouts || 0));
    const edgeAdd = CONFIG.EDGE_UPCHARGES[edge] ?? 0;

    // Base: if sqft > 0 use sqft*qty; else qty only
    const base = s > 0 ? (p * s * (q > 0 ? q : 1)) : (p * (q > 0 ? q : 1));
    const cutoutsAdd = c * CONFIG.CUTOUT_PRICE;

    return base + cutoutsAdd + edgeAdd;
  }

  function renderTotals(){
    const subtotal = state.items.reduce((acc, it) => acc + it.line_total, 0);
    elSubtotal.textContent = fmt(subtotal);
  }

  function renderTable(){
    elTbody.innerHTML = '';
    if (state.items.length === 0){
      elTbody.appendChild(elEmpty);
      elEmpty.hidden = false;
      renderTotals();
      return;
    }
    elEmpty.hidden = true;

    state.items.forEach((it, idx) => {
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td>${it.collection || ''}</td>
        <td>${it.type || ''}</td>
        <td class="qb-cell-wrap">${it.product_title || ''}</td>
        <td>${it.sku || ''}</td>
        <td>${it.sqft || ''}</td>
        <td>${it.cutouts || ''}</td>
        <td>${it.edge || ''}</td>
        <td>${it.qty || ''}</td>
        <td class="qb-price">${fmt(it.unit_price)}</td>
        <td class="qb-price">${fmt(it.line_total)}</td>
        <td><button class="qb-btn qb-del" data-del="${idx}">Remove</button></td>
      `;
      elTbody.appendChild(tr);
    });

    $$('button[data-del]').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const i = Number(btn.getAttribute('data-del'));
        state.items.splice(i,1);
        renderTable();
        renderTotals();
      });
    });

    renderTotals();
  }

  function clearAfterCollection(){
    elType.innerHTML = `<option value="">All</option>`;
    elType.disabled = true;

    elProduct.innerHTML = `<option value="">Select a product</option>`;
    elProduct.disabled = true;

    elVariant.innerHTML = `<option value="">Select a variant</option>`;
    elVariant.disabled = true;
  }

  async function fetchProductsForCollection(handle){
    const all = [];
    let page = 1;
    const limit = 250;

    while (true){
      const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}&page=${page}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) break;
      const data = await res.json();
      const batch = data?.products || [];
      all.push(...batch);
      if (batch.length < limit) break;
      page++;
    }
    return all;
  }

  function hydrateTypes(){
    const types = unique(state.products.map(p => p.product_type).filter(Boolean)).sort();
    elType.innerHTML = `<option value="">All</option>` + types.map(t => `<option value="${t}">${t}</option>`).join('');
    elType.disabled = false;
  }

  function filterProducts(){
    const typ = elType.value;
    state.filtered = state.products.filter(p => !typ || (p.product_type || '') === typ);

    elProduct.innerHTML = `<option value="">Select a product</option>` + state.filtered.map(p => {
      return `<option value="${p.id}">${p.title}</option>`;
    }).join('');

    elProduct.disabled = state.filtered.length === 0;
    elVariant.innerHTML = `<option value="">Select a variant</option>`;
    elVariant.disabled = true;
  }

  function populateVariants(){
    const id = elProduct.value;
    const product = state.filtered.find(p => String(p.id) === String(id));
    if (!product){
      elVariant.innerHTML = `<option value="">Select a variant</option>`;
      elVariant.disabled = true;
      return;
    }

    elVariant.innerHTML = `<option value="">Select a variant</option>` + (product.variants || []).map(v => {
      const sku = v.sku || 'N/A';
      const price = Number(v.price || 0);
      return `<option value="${v.id}" data-sku="${sku}" data-price="${price}">${v.title} — ${sku} — ${fmt(price)}</option>`;
    }).join('');
    elVariant.disabled = false;
  }

  function addItem(){
    const productId = elProduct.value;
    const variantId = elVariant.value;
    if (!state.currentCollection.handle){
      alert('Please choose a Collection.');
      return;
    }
    if (!productId || !variantId){
      alert('Please choose a Product and Variant.');
      return;
    }

    const product = state.filtered.find(p => String(p.id) === String(productId));
    const vOpt = elVariant.selectedOptions[0];
    const sku = vOpt?.getAttribute('data-sku') || 'N/A';
    const price = Number(vOpt?.getAttribute('data-price') || 0);

    const sqft    = (elSqft.value || '').trim();
    const cutouts = (elCutouts.value || '').trim();
    const edge    = (elEdge.value || '').trim();
    const qty     = (elQty.value || '').trim() || '1';
    const note    = (elNote.value || '').trim();

    const item = {
      collection: state.currentCollection.title || state.currentCollection.handle,
      type: product.product_type || '',
      product_id: product.id,
      product_title: product.title,
      variant_id: variantId,
      variant_title: vOpt ? vOpt.textContent.split(' — ')[0] : '',
      sku,
      sqft,
      cutouts,
      edge,
      qty,
      note,
      unit_price: price,
      line_total: 0
    };

    item.line_total = computeLineTotal(
      item.unit_price,
      item.sqft,
      item.qty,
      item.cutouts,
      item.edge
    );

    state.items.push(item);
    renderTable();
    resetAddForm(true);
  }

  function validateCustomer(){
    if (!elName.value.trim()) return "Please enter your full name.";
    if (!elEmail.value.trim()) return "Please enter your email.";

    const phoneDigits = (elPhone.value || '').replace(/\D+/g,'');
    if (phoneDigits.length !== 10) return "Please enter a valid 10-digit phone number.";

    if (state.items.length === 0) return "Please add at least one item to your quote.";
    return "";
  }

  // Phone mask: (xxx)-xxx-xxxx
  function formatPhoneDisplay(raw) {
    const digits = String(raw || '').replace(/\D+/g,'').slice(0, 10);
    const [a,b,c] = [digits.slice(0,3), digits.slice(3,6), digits.slice(6,10)];
    if (digits.length <= 3) return a ? `(${a})` : '';
    if (digits.length <= 6) return `(${a})-${b}`;
    return `(${a})-${b}-${c}`;
  }
  function getPhoneRaw() {
    return (elPhone.value || '').replace(/\D+/g,'').slice(0, 10);
  }

  function buildSummary(){
    const body = {
      customer: {
        name: elName.value.trim(),
        email: elEmail.value.trim(),
        phone: getPhoneRaw(),                 // digits-only for backend
        phone_display: elPhone.value.trim(),  // formatted for humans
        phone_ext: (elPhoneExt?.value || '').trim(),
        address: elAddress.value.trim(),
        note: elCustNote.value.trim()
      },
      items: state.items,
      totals: {
        currency: CONFIG.CURRENCY,
        subtotal: state.items.reduce((a,b)=>a + b.line_total, 0)
      },
      meta: {
        generated_at: new Date().toISOString(),
        support_phone: CONFIG.PHONE_SUPPORT,
        support_address: CONFIG.ADDRESS_SUPPORT
      }
    };
    return body;
  }

  async function submitQuote(){
    const err = validateCustomer();
    if (err){
      elStatus.textContent = err;
      return;
    }

    const payload = buildSummary();
    const pretty = JSON.stringify(payload, null, 2);

    // Web3Forms payload
    const fd = new FormData();
    fd.append("access_key", CONFIG.WEB3FORMS_ACCESS_KEY);
    fd.append("subject", "New Quote Request");
    fd.append("from_name", payload.customer.name);
    fd.append("from_email", payload.customer.email);
    fd.append("message", "Quote request submitted from Shopify Quote page.");
    fd.append("customer_name", payload.customer.name);
    fd.append("customer_email", payload.customer.email);
    fd.append("customer_phone", payload.customer.phone_display);
    if (payload.customer.phone_ext) fd.append("customer_phone_ext", payload.customer.phone_ext);
    if (payload.customer.address) fd.append("customer_address", payload.customer.address);
    if (payload.customer.note) fd.append("customer_note", payload.customer.note);
    fd.append("quote_currency", payload.totals.currency);
    fd.append("quote_subtotal", String(payload.totals.subtotal));
    fd.append("quote_items_json", pretty);

    elSubmit.disabled = true;
    elStatus.textContent = "Submitting...";

    try{
      const res = await fetch("https://api.web3forms.com/submit", { method: "POST", body: fd });

      if (!res.ok){
        if (res.status === 429){
          elStatus.textContent = "Too many requests. Please try again later.";
        } else {
          elStatus.textContent = "Submission failed. Please try again.";
        }
        elSubmit.disabled = false;
        return;
      }

      const data = await res.json();
      if (data?.success){
        // Show modal with pretty summary
        elModalSummary.innerHTML = renderPrettySummary(payload);
        openModal();

        // Reset cart & customer form
        state.items = [];
        renderTable(); renderTotals();
        elName.value = ""; elEmail.value = ""; elPhone.value = "";
        if (elPhoneExt) elPhoneExt.value = "";
        elAddress.value = ""; elCustNote.value = "";
        elStatus.textContent = "Submitted!";
      } else {
        elStatus.textContent = "Submission error. Please check your inputs.";
      }
    } catch(err){
      console.error(err);
      elStatus.textContent = "Network error. Please try again.";
    } finally {
      elSubmit.disabled = false;
    }
  }

  // Print ONLY the summary using a hidden iframe (no popups)
  function printSummaryInIframe(html){
    const iframe = document.getElementById('qb-print-frame');
    if (!iframe) { alert('Print frame not found.'); return; }
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) { alert('Cannot access print frame.'); return; }

    const styles = `
      <style>
        body { font-family: Inter, system-ui, Segoe UI, Arial, sans-serif; color:#0f172a; margin: 20px; }
        h2 { margin: 0 0 8px; font-size: 20px; }
        .qb-s-grid { display:grid; gap:12px; grid-template-columns: 2fr 1fr; margin:8px 0 14px; }
        @media (max-width: 720px){ .qb-s-grid { grid-template-columns:1fr; } }
        .qb-s-card { border:1px solid #e2e8f0; border-radius:12px; padding:12px; background:#f8fafc; }
        .qb-s-card h3 { margin:0 0 8px; font-size:16px; }
        .qb-kv { display:grid; grid-template-columns:120px 1fr; gap:6px 10px; font-size:14px; }
        .qb-kv span:first-child { color:#64748b; }
        .qb-total { font-size: 20px; font-weight:700; }
        .qb-small { color:#64748b; font-size:12px; margin-top:6px; }
        .qb-s-table { width:100%; border-collapse: collapse; font-size:14px; }
        .qb-s-table th, .qb-s-table td { padding:8px 10px; border-bottom:1px solid #e2e8f0; text-align:left; vertical-align:top; }
        .qb-s-right { text-align:right; }
        .qb-wrap-text { white-space: normal; word-break: break-word; overflow-wrap: anywhere; }
        @media print { body { margin: 0.5in; } }
      </style>
    `;

    doc.open();
    doc.write(`<!doctype html><html><head><meta charset="utf-8">${styles}</head><body>
      <h2>Quote Summary</h2>
      ${html}
    </body></html>`);
    doc.close();

    const win = iframe.contentWindow || iframe;
    setTimeout(() => win.print(), 50);
  }

  // Events
  function bindEvents(){
    elCollection.addEventListener('change', async ()=>{
      const handle = elCollection.value;
      const title  = elCollection.selectedOptions[0]?.textContent || "";
      state.currentCollection = { handle, title };
      clearAfterCollection();

      if (!handle){
        state.products = [];
        return;
      }

      elStatus.textContent = "Loading products…";
      try{
        const prods = await fetchProductsForCollection(handle);
        prods.forEach(p => { p.tags = p.tags || []; });
        state.products = prods;
        hydrateTypes();
        filterProducts();
        elStatus.textContent = "";
      } catch(e){
        console.error(e);
        elStatus.textContent = "Could not load products for this collection.";
      }
    });

    // Phone input mask
    elPhone.addEventListener('input', () => {
      const before = elPhone.value;
      elPhone.value = formatPhoneDisplay(before);
      try { elPhone.setSelectionRange(elPhone.value.length, elPhone.value.length); } catch(_) {}
    });

    elType.addEventListener('change', filterProducts);
    elProduct.addEventListener('change', populateVariants);
    elAdd.addEventListener('click', addItem);
    elSubmit.addEventListener('click', submitQuote);

    // Modal interactions
    elModal?.addEventListener('click', (e)=>{
      if (e.target.matches('[data-qb-close]') || e.target === elModal) closeModal();
    });
    elModalNew?.addEventListener('click', closeModal);

    // Print (no popup)
    elModalDownload?.addEventListener('click', () => {
      const html = elModalSummary?.innerHTML || '';
      if (!html.trim()) return;
      printSummaryInIframe(html);
    });
  }

  (function init(){
    bindEvents();
    clearAfterCollection();
  })();
})();
